// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Initial fade-in without scroll
const tl3imgfade = gsap.timeline();
tl3imgfade.to(".fade-img:nth-child(1)", { opacity: 1, duration: 1, ease: "power3.inOut" });
tl3imgfade.to(".fade-img:nth-child(2)", { opacity: 1, duration: 1, ease: "power3.inOut" }, "-=0.5");
tl3imgfade.to(".fade-img:nth-child(3)", { opacity: 1, duration: 1, ease: "power3.inOut" }, "-=0.5");

// Scroll-triggered fade-out and fade-in
// gsap.timeline({
//   scrollTrigger: {
//     trigger: ".kg-3-img-fadein",
//     start: "top top",
//     end: "bottom top",
//     scrub: true,  
//     toggleActions: "play none none reverse"
//   }
// })
// .to(".fade-img:nth-child(1)", { opacity: 1, duration: 1, ease: "power3.inOut" })
// .to(".fade-img:nth-child(2)", { opacity: 1, duration: 1, ease: "power3.inOut" }, "-=0.5")
// .to(".fade-img:nth-child(3)", { opacity: 1, duration: 1, ease: "power3.inOut" }, "-=0.5")
// .to(".fade-img:nth-child(1)", { opacity: 0, duration: 1, ease: "power3.inOut" })
// .to(".fade-img:nth-child(2)", { opacity: 0, duration: 1, ease: "power3.inOut" }, "-=0.5")
// .to(".fade-img:nth-child(3)", { opacity: 0, duration: 1, ease: "power3.inOut" }, "-=0.5");

